import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=50bf97d2&scoped=true&"
var script = {}
import style0 from "./Page404.vue?vue&type=style&index=0&id=50bf97d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf97d2",
  null
  
)

export default component.exports